import React from 'react';

const Spinner = () => (
  <div className="vx_mainContent spinner display-none">
    <div className="vx_spinner-large center-content" />
  </div>
);

export default Spinner;
